import { useContext, useEffect, useState } from "react";
import { ModalContext } from "../../../utils/modal/ModalProvider";
import styles from "../../../utils/modal/DetailModal.module.css";
import { IAM_PATH, IAM_SERVER_SERVICE_USER } from "../../../utils/Config";
import axios from "../../../utils/api/axios";
import { containsXss } from "../../../utils/security/XssFilter";
import { DialogEnum, showDialog } from "../../../utils/dialog/Dialog";
import Switch from "@mui/material/Switch";
import Loading from "../../../utils/loading/Loading";
import { isEmailSimple } from "../../../utils/modal/ValidEmail";
// import {SensorListContainer} from "./SensorListContainer";

export const ADMINROLE = {
    SYS_ADMIN: 'SYS_ADMIN',
    ADMIN_USER: 'ADMIN_USER'
}

export const ADMINROLE_LABEL = {
    SYS_ADMIN: '시스템관리자',
    ADMIN_USER: '일반사용자'
};

/**
 * 사용자 상세정보 모달 Container
 * @param id
 * @param update
 * @returns {JSX.Element}
 * @constructor
 */
export const ServiceUserDetailModal = ({ id, update, idToNameMap }) => {

    const { closeModal } = useContext(ModalContext);

    const [loading, setLoading] = useState(true);
    const [isNull, setIsNull] = useState(false); //빈 값 확인
    const [checked, setChecked] = useState(false); // 비밀번호 변경 옵션(Switch)

    const [formData, setFormData] = useState({
        id: id,
        userId: '',
        password: '',
        passwordConfirm: '',
        userName: '',
        email: '',
        phone: '',
        groupId: '0',
        role: '',
        status: ''
    });

    useEffect(() => {
        fetchAdminInfo();
    }, []);

    const fetchAdminInfo = () => {
        // id로 사용자 정보 조회
        const url = IAM_PATH + IAM_SERVER_SERVICE_USER + "/get/" + id;
        axios.get(url)
            .then((res) => {
                setFormData({
                    userId: res.data.data.userId,
                    password: '',
                    passwordConfirm: '',
                    userName: res.data.data.userName,
                    email: res.data.data.email,
                    phone: res.data.data.phone,
                    groupId: res.data.data.groupId,
                    groupName: res.data.data.groupName,
                    role: res.data.data.role,
                    status: res.data.data.status
                });
            })
            .catch((e) => {
                console.error(e);
                // showDialog(DialogEnum.DEFAULT, "실패", e.respnose.data.resultMessage); todo
                showDialog(DialogEnum.DEFAULT, "실패", "사용자 정보 조회에 실패했습니다.");
            })
            .finally(() => {
                setLoading(false);
            })
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    }

    useEffect(() => {
    }, [formData]);

    // function isEmailSimple(str) {
    //     return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(str).trim());
    // }

    const handleUpdate = (item) => {
        let isValid = true;

        for (let key in formData) {
            if (key === 'email') {
                if(!isEmailSimple(formData[key])){
                    showDialog(DialogEnum.DEFAULT, "경고", "올바른 이메일을 입력해 주세요.");
                    isValid = false;
                    break;
                }
            }

            if (formData[key] === '') {
                if (!checked) {
                    if (!(key === 'password' || key === 'passwordConfirm')) {
                        setIsNull(true);
                        isValid = false;
                        break;
                    }
                } else {
                    setIsNull(true);
                    isValid = false;
                    break;
                }
            } else if (containsXss(formData[key])) {
                setFormData((prevState) => ({
                    ...prevState,
                    [key]: ''
                }))
                setIsNull(true);
                showDialog(DialogEnum.DEFAULT, "경고", "올바른 값을 입력해 주세요.");
                isValid = false;
                break;
            }
        }

        if (!isValid) return;
        setIsNull(false);

        const params = Object.assign({}, formData);
        params.id = id

        // 비밀번호 확인
        if (formData.passwordConfirm && formData.passwordConfirm !== formData.password) {
            showDialog(DialogEnum.DEFAULT, "경고", "비밀번호가 일치하지 않습니다.");
            return;
        }

        if (!formData.passwordConfirm) {
            delete params.passwordConfirm;
        }

        const url = `${IAM_PATH}${IAM_SERVER_SERVICE_USER}/update/myinfo`;
        axios.post(url, params)
            .then((res) => {
                if (res.data.code == 200) {
                    showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);
                } else {
                    showDialog(DialogEnum.FAIL, "실패", res.data.message);
                }
                //update();
            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
            });
    }


    const handleCancle = () => {
        closeModal();
    }

    return (
        <div style={{ overflow: "auto" }}>
            {loading ? <Loading /> :
                <div>
                    <ul className={styles.layer__listWrap}>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>아이디</p>
                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"id"}
                                value={formData.userId}
                                readOnly={true}
                                style={{ backgroundColor: '#00000010', cursor: "default" }}
                            />
                        </li>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>비밀번호</p>
                            <input className={styles.layer__listInput}
                                type={"password"}
                                name={"password"}
                                value={checked ? formData.password : '00000000000000000000'}
                                readOnly={!checked} //switch 변경시 변하도록 수정
                                maxLength={20}
                                onChange={handleChange}
                                style={!checked ? { backgroundColor: '#00000010', cursor: "default" } : undefined}
                            />
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Switch
                                    checked={checked}
                                    onChange={(e) => setChecked(e.target.checked)}
                                    color="primary"
                                    size="small"
                                />
                                <span style={{ fontSize: '12px' }}>변경</span>
                            </div>
                        </li>
                        {checked && (
                            <li className={styles.layer__list}>
                                <p className={styles.layer__listTit}>비밀번호 확인</p>
                                <input className={styles.layer__listInput}
                                    type={"password"}
                                    name={"passwordConfirm"}
                                    value={formData.passwordConfirm ?? ''}
                                    readOnly={false}
                                    maxLength={20}
                                    onChange={handleChange} />
                            </li>
                        )}
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>이름</p>
                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"userName"}
                                value={formData.userName}
                                readOnly={false}
                                maxLength={20}
                                onChange={handleChange} />
                        </li>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>전화번호</p>
                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"phone"}
                                value={formData.phone}
                                readOnly={false}
                                maxLength={20}
                                onChange={handleChange} />
                        </li>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>이메일</p>
                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"email"}
                                value={formData.email}
                                readOnly={false}
                                maxLength={319}
                                onChange={handleChange} />
                        </li>
                        {formData.role !== ADMINROLE.SYS_ADMIN && (
                            <li className={styles.layer__list}>
                                <p className={styles.layer__listTit}>그룹명</p>
                                <input
                                    className={styles.layer__listInput}
                                    name="groupId"
                                    value={formData.groupName} //실제 그룹명이 보이도록 수정
                                    onChange={handleChange}
                                    readOnly={true}
                                    style={{ backgroundColor: '#00000010', cursor: "default" }}
                                />
                            </li>
                        )}
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>권한</p>
                            <input
                                className={styles.layer__listInput}
                                name="role"
                                // value={formData.role} //실제 권한명이 보이도록 수정
                                value={ADMINROLE_LABEL[formData.role] || '알 수 없음'}
                                onChange={handleChange}
                                readOnly={true}
                                style={{ backgroundColor: '#00000010', cursor: "default" }}
                            />
                        </li>
                    </ul>
                    {isNull ? <div className={`${styles.layer__text} ${styles.warning}`}>빈 칸을 확인해 주세요.</div> : null}
                    {/* <div className={styles.layer__sensorBox}>
                        <p className={styles.layer__sensorTit}>서비스 정보</p>
                        <SensorListContainer id={id} detailList={detailList} update={update}/>
                    </div> */}

                    <div className={styles.layer__sensorBtnBox}>
                        <button className={styles.layer__statusBtn__green} onClick={() => handleUpdate(formData)}>수정</button>
                    </div>
                </div>
            }
        </div>
    );
}